export const apiRoutes = {
  api_r_user_global_getModulePayload: {
    path: 'global/get-module-payload/',
  },
};
